import ChangePwPage from "./ChangePwPage";

export default ChangePwPage;
